/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */
import { useMutation } from '@tanstack/react-query';
import { apiClient } from '@lib/api-client';
import { notifications } from '@mantine/notifications';

// I18n
import { useTranslation } from 'react-i18next';

// Types
import { IApiError } from '@global-types/index';
import { queryClient } from '@lib/react-query';

/* -------------------------------------------------------------------------- */
/*                                     Type                                   */
/* -------------------------------------------------------------------------- */

type TApiResponse = { id: string; active: boolean };

/* -------------------------------------------------------------------------- */
/*                                     Api                                    */
/* -------------------------------------------------------------------------- */
export const activateAdditionalityProject = (data: {
	active: boolean;
	ids: string[];
}): Promise<TApiResponse> => {
	return apiClient.patch(
		`/additionalities/activate`,
		data
	);
};

export const useActivateAdditionalityProject = () => {
	const { t } = useTranslation();
	const {
		mutate,
		isPending: isLoading,
		isSuccess,
	} = useMutation({
		mutationFn: activateAdditionalityProject,
		onSuccess: (response) => {
			if (response && Array.isArray(response)) {
				let id;

				id = response[0].id;
				queryClient.invalidateQueries({
					queryKey: ['additionality-project-update', id],
				});

				queryClient.invalidateQueries({
					queryKey: ['additionality-projects', id],
				});
			}
		},
		onError: (error: IApiError) => {
			notifications.show({
				title: t('global.error'),
				message: t(`api.${error.type}`),
				color: 'error',
			});
		},
	});

	return { mutate, isLoading, isSuccess };
};
